import React from "react"
import LayoutWithMenu from "../../layouts/LayoutWithMenu";
import { renderRoutes } from "react-router-config";

import { observer } from "mobx-react";
import DeleteModifiersSetForm from "./pages/modifiersSet/components/DeleteModifiersSetForm";
import UpdateAliasForm from "./pages/orderSettingsPage/components/UpdateAliasForm";

const MenuLayout = ({route}: {route?: any}) => {
    return <LayoutWithMenu route={route}>
            <UpdateAliasForm/>
            <DeleteModifiersSetForm/>
        {renderRoutes(route.routes)}
    </LayoutWithMenu>
};


export default observer(MenuLayout)
